/* ============================================================
   VECTOR EDGE - UNIFIED DESIGNER ENGINE
   Products register themselves (ve-designer-products-*.js); this
   file owns state, the step controls, the production size limits,
   pricing (bracket tiers snapped to the price-anchor ladder) and
   the cart. Data + drawing helpers live in ve-designer-draw.js.
   ============================================================ */
(function () {
  'use strict';
  /* Load order: draw (registry + data) -> products 1..4 -> core LAST, so every
     product is registered before init runs. */
  var VED = window.VED = window.VED || {};
  /* product files may add their own tier sets before this runs, so merge rather than replace */
  VED.TIERS = Object.assign(VED.TIERS || {}, {
    none:  [{ min: 1, mult: 1 }],
    decal: [{ min: 1, mult: 1 }, { min: 10, mult: .68 }, { min: 25, mult: .5 }, { min: 50, mult: .45 }, { min: 100, mult: .35 }, { min: 250, mult: .28 }, { min: 500, mult: .23 }],
    sign:  [{ min: 1, mult: 1 }, { min: 2, mult: .9 }, { min: 5, mult: .78 }, { min: 10, mult: .65 }, { min: 25, mult: .55 }, { min: 50, mult: .5 }]
  });

  var root, cfg, S, anchors = {}, notes = {}, files = {}, opts = {};
  var $ = function (s, r) { return (r || root).querySelector(s); };
  var esc = VED.esc = function (t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var money = function (n) { return '£' + (Math.round(n * 100) / 100).toFixed(2).replace(/\.00$/, ''); };
  var quoteLink = function (t) { return '<a href="' + esc(opts.quote) + '">' + (t || 'Get a free mockup and price') + '</a>'; };
  var val = function (o, s) { return typeof o === 'function' ? o(s, api) : o; };

  function snap(p) {
    p = Math.max(0, +p || 0);
    if (p <= 250) return Math.max(5, Math.ceil(p / 5) * 5);
    if (p <= 500) return Math.ceil(p / 10) * 10;
    return Math.ceil(p / 25) * 25;
  }

  /* ---------- api handed to every product config ---------- */
  var api = VED.api = {
    esc: esc, quoteLink: quoteLink, LIMITS: VED.LIMITS,
    colour: function (name, pal) { return VED.colour(name, pal); },
    file: function (id) { return files[cfg.key + ':' + id] || null; },
    lines: function (t) { return String(t || '').split(/\r?\n/).map(function (x) { return x.trim(); }).filter(Boolean); }
  };

  /* ---------- state ---------- */
  function initState(c) {
    var s = {};
    c.steps.forEach(function (st) {
      if (st.t === 'size') st.fields.forEach(function (f) { s[st.id + '_' + f.k] = f.v; });
      else if (st.t === 'hours') s[st.id] = { mon: ['09:00', '17:30'], tue: ['09:00', '17:30'], wed: ['09:00', '17:30'], thu: ['09:00', '17:30'], fri: ['09:00', '17:30'], sat: ['10:00', '16:00'], sun: ['', ''] };
      else if (st.t === 'gen') { s.gen_p = 'VE-'; s.gen_s = 1; s.gen_n = 50; s.gen_pad = 4; s.gen_x = ''; }
      else if (st.t === 'vehicle') { s.veh_make = ''; s.veh_model = ''; s.veh_year = ''; s.veh_body = 'Hatchback'; }
      else if (st.t === 'qty') s.qty = st.v || 1;
      else if (st.t === 'confirm') s[st.id] = false;
      else if (st.id && st.t !== 'upload') s[st.id] = Array.isArray(st.v) ? st.v.slice() : (st.v == null ? '' : st.v);
    });
    return s;
  }
  /* cfg.remember = answer keys kept in this browser between visits and shared by every designer that lists
     them (2026-10-23: the customer's car and paint carry over between the stripe and numbers designers).
     Storage can be missing or blocked (private windows): then the designer just starts fresh. */
  var MINE = 'ved-mine';
  function recall(s) {
    var m; try { m = JSON.parse(localStorage.getItem(MINE) || '{}'); } catch (e) { return; }
    (cfg.remember || []).forEach(function (k) {
      var v = m[k];
      if (typeof v !== 'string' || v.length > 60) return;
      if (k === 'veh_body' && (VED.BODIES || []).indexOf(v) < 0) return;   /* a body type no longer offered */
      s[k] = v;
    });
  }
  function keep() {
    if (!cfg.remember) return;
    try { var m = JSON.parse(localStorage.getItem(MINE) || '{}'); cfg.remember.forEach(function (k) { if (S[k] != null) m[k] = S[k]; }); localStorage.setItem(MINE, JSON.stringify(m)); } catch (e) {}
  }
  function qtyOf() { return Math.max(1, cfg.qty ? cfg.qty(S, api) : (S.qty || 1)); }

  /* ---------- pricing ---------- */
  /* tiers, qty presets and qty minimum may be functions of the answers */
  function tiers() { return VED.TIERS[val(cfg.tiers, S) || 'none']; }
  function qtyMin(st) { return val(st.min, S) || 1; }
  function rawTotal(unit, qty) {
    var T = tiers(), sum = 0;
    for (var i = 0; i < T.length && qty >= T[i].min; i++) {
      var end = i + 1 < T.length ? T[i + 1].min - 1 : Infinity;
      sum += (Math.min(qty, end) - T[i].min + 1) * unit * T[i].mult;   /* marginal bands: total never falls */
    }
    return Math.max(sum, cfg.minTotal || 0);
  }
  function priceNow() {
    var qty = qtyOf(), unit = Math.max(0, cfg.unit(S, api)), total = snap(rawTotal(unit, qty));
    var map = anchors[cfg.anchor] || {};
    return { qty: qty, total: total, each: total / qty, variant: map[total] || null };
  }

  /* ---------- step controls ---------- */
  var ID = function (st, k) { return 'ved-' + cfg.key + '-' + st.id + (k ? '-' + k : ''); };
  var C = {
    text: function (st) { return '<input class="ved-field" id="' + ID(st) + '" data-k="' + st.id + '" maxlength="' + (st.max || 60) + '" value="' + esc(S[st.id]) + '" placeholder="' + esc(st.ph || '') + '" aria-label="' + esc(st.label) + '">' + (st.max ? '<span class="ved-sub ved-count" data-count="' + st.id + '">' + String(S[st.id]).length + ' / ' + st.max + '</span>' : ''); },
    area: function (st) { return '<textarea class="ved-area" id="' + ID(st) + '" data-k="' + st.id + '" placeholder="' + esc(st.ph || '') + '" aria-label="' + esc(st.label || 'List') + '">' + esc(S[st.id]) + '</textarea>'; },
    upload: function (st) {
      var f = files[cfg.key + ':' + st.id];
      return '<label class="ved-upload"><span>' + esc(st.cap || 'Upload artwork') + '</span><small>' + esc(st.types || 'PDF · SVG · PNG · JPG · max 20 MB') + '</small><input type="file" id="' + ID(st) + '" data-up="' + st.id + '" accept="' + esc(st.accept || '.pdf,.svg,.png,.jpg,.jpeg,.webp') + '"></label>' +
        (f ? '<div class="ved-file"><span>' + esc(f.name) + (f.w ? ' · ' + f.w + ' × ' + f.h + ' px' : '') + '</span><button type="button" data-rm="' + st.id + '">Remove</button></div>' : '');
    },
    size: function (st) {
      var pre = st.presets ? '<div class="ved-chips">' + st.presets.map(function (p) { var on = p.every(function (v, i) { return S[st.id + '_' + st.fields[i].k] === v; }); return '<button type="button" class="ved-chip" data-preset="' + st.id + '" data-v="' + p.join(',') + '" aria-pressed="' + on + '">' + p.join(' × ') + '</button>'; }).join('') + '</div>' : '';
      return '<div class="ved-dims">' + st.fields.map(function (f) { return '<label class="ved-dim"><input type="number" inputmode="decimal" id="' + ID(st, f.k) + '" data-k="' + st.id + '_' + f.k + '" data-size="' + st.id + '" min="' + val(f.min, S) + '" max="' + val(f.max, S) + '" step="' + (f.step || 1) + '" value="' + S[st.id + '_' + f.k] + '"><span>' + (st.unit || 'cm') + ' ' + esc(f.l) + '</span></label>'; }).join('') + '</div>' + pre;
    },
    cards: function (st, picker) {
      return '<div class="ved-cards' + (picker ? ' ved-picker' : '') + '">' + val(st.opts, S).map(function (o) {
        var off = o[3] ? ' disabled title="' + esc(o[3]) + '"' : '';
        return '<button type="button" class="ved-card" data-set="' + st.id + '" data-v="' + esc(o[0]) + '" aria-pressed="' + (S[st.id] === o[0]) + '"' + off + '>' + (picker && o[4] ? '<svg viewBox="0 0 100 60" aria-hidden="true">' + o[4] + '</svg>' : '') + '<span class="h">' + esc(o[0]) + '</span>' + (o[1] ? '<span class="s">' + esc(o[1]) + '</span>' : '') + (o[2] ? '<span class="x">' + esc(o[2]) + '</span>' : '') + '</button>';
      }).join('') + '</div>';
    },
    picker: function (st) { return C.cards(st, true); },
    chips: function (st) {
      return '<div class="ved-chips">' + val(st.opts, S).map(function (o) { var on = st.multi ? S[st.id].indexOf(o) > -1 : S[st.id] === o; return '<button type="button" class="ved-chip" data-set="' + st.id + '" data-v="' + esc(o) + '"' + (st.multi ? ' data-multi="1"' : '') + ' aria-pressed="' + on + '">' + esc(o) + '</button>'; }).join('') + '</div>';
    },
    font: function (st) {
      return '<div class="ved-chips ved-fonts">' + Object.keys(VED.FONTS).map(function (k) { var f = VED.FONTS[k]; return '<button type="button" class="ved-chip" data-set="' + st.id + '" data-v="' + esc(k) + '" style="font-family:' + esc(f.css) + ';font-weight:' + f.w + '" aria-pressed="' + (S[st.id] === k) + '">' + esc(k) + '</button>'; }).join('') + '</div>';
    },
    colour: function (st) {
      var pal = VED.PALETTES[st.palette || 'oracal'], cur = VED.colour(S[st.id], st.palette);
      return '<div class="ved-swatches">' + pal.map(function (c) { return '<button type="button" class="ved-sw" style="background:' + c.hex + '" data-set="' + st.id + '" data-v="' + esc(c.name) + '" title="' + esc(c.name) + '" aria-label="' + esc(c.name) + '"' + (c.premium ? ' data-prem="1"' : '') + ' aria-pressed="' + (S[st.id] === c.name) + '"></button>'; }).join('') + (st.custom ? '<label class="ved-sw ved-sw-custom" title="Pick any colour" aria-pressed="' + (/^#/.test(S[st.id])) + '"><input type="color" data-k="' + st.id + '" value="' + esc(cur.hex) + '" aria-label="Pick any colour"></label>' : '') + '</div><span class="ved-sub">' + esc(cur.name) + (cur.code ? ' · ' + cur.code : '') + (cur.premium ? ' · metallic, +50%' : '') + '</span>';
    },
    hours: function (st) {
      return VED.DAYS.map(function (d) { var k = d.slice(0, 3).toLowerCase(), v = S[st.id][k]; return '<div class="ved-dayrow"><span class="ved-sub">' + d + '</span><input class="ved-field" type="time" id="' + ID(st, k + 'o') + '" data-hr="' + st.id + '" data-day="' + k + '" data-i="0" value="' + esc(v[0]) + '" aria-label="' + d + ' opens"><input class="ved-field" type="time" id="' + ID(st, k + 'c') + '" data-hr="' + st.id + '" data-day="' + k + '" data-i="1" value="' + esc(v[1]) + '" aria-label="' + d + ' closes"></div>'; }).join('');
    },
    gen: function (st) {
      var f = function (k, l, type, extra) { return '<label class="ved-sub">' + l + '<input class="ved-field" id="' + ID(st, k) + '" data-k="gen_' + k + '" ' + (type === 'n' ? 'type="number" ' : '') + (extra || '') + ' value="' + esc(S['gen_' + k]) + '"></label>'; };
      return '<div class="ved-row">' + f('p', 'Prefix', 't', 'maxlength="12"') + f('s', 'Start number', 'n', 'min="0"') + f('n', 'How many', 'n', 'min="1" max="1000"') + f('pad', 'Digits', 'n', 'min="1" max="8"') + f('x', 'Suffix', 't', 'maxlength="6"') + '</div>';
    },
    vehicle: function (st) {
      return '<div class="ved-row"><select class="ved-select" id="' + ID(st, 'make') + '" data-k="veh_make" aria-label="Make"><option value="">Make…</option>' + VED.MAKES.map(function (m) { return '<option' + (m === S.veh_make ? ' selected' : '') + '>' + m + '</option>'; }).join('') + '</select>' +
        '<input class="ved-field" id="' + ID(st, 'model') + '" data-k="veh_model" maxlength="40" placeholder="Model, e.g. Fiesta ST" value="' + esc(S.veh_model) + '" aria-label="Model">' +
        '<input class="ved-field" id="' + ID(st, 'year') + '" data-k="veh_year" type="number" min="1960" max="' + (new Date().getFullYear() + 1) + '" placeholder="Year" value="' + esc(S.veh_year) + '" aria-label="Year"></div>' +
        '<div class="ved-chips">' + VED.BODIES.map(function (o) { return '<button type="button" class="ved-chip" data-set="veh_body" data-v="' + o + '" aria-pressed="' + (S.veh_body === o) + '">' + o + '</button>'; }).join('') + '</div>';
    },
    qty: function (st) {
      var T = tiers(), q = S.qty, idx = 0, presets = val(st.presets, S);
      T.forEach(function (t, i) { if (q >= t.min) idx = i; });
      var pre = presets ? presets.map(function (p) { return '<button type="button" class="ved-chip" data-qset="' + p + '" aria-pressed="' + (q === p) + '">' + p + '</button>'; }).join('') : '';
      return '<div class="ved-qty"><button type="button" data-q="-1" aria-label="One fewer">−</button><input class="ved-field" id="' + ID(st) + '" type="number" min="' + qtyMin(st) + '" data-k="qty" value="' + q + '" aria-label="Quantity"><button type="button" data-q="1" aria-label="One more">+</button>' + pre + '</div>' +
        (T.length > 1 ? '<div class="ved-tiers">' + T.map(function (t, i) { return '<span class="' + (i === idx ? 'on' : '') + '">' + t.min + '+ ' + (t.mult === 1 ? 'base' : '−' + Math.round((1 - t.mult) * 100) + '%') + '</span>'; }).join('') + '</div>' : '');
    },
    confirm: function (st) { return '<label class="ved-check"><input type="checkbox" id="' + ID(st) + '" data-tick="' + st.id + '"' + (S[st.id] ? ' checked' : '') + '><span>' + esc(st.text) + '</span></label>'; },
    info: function (st) { return '<div class="ved-note is-info">' + val(st.html, S) + '</div>'; }
  };

  /* ---------- update in place ----------
     Every click re-renders the steps and the preview as HTML strings. Swapping them in wholesale
     rebuilt ~700 nodes (93 style thumbnails), reset the style box's scroll and re-created the
     car photo layers, so the browser re-decoded and re-blended them. morph() keeps every node
     that did not change and patches only what did (usually a couple of attributes). */
  function syncAttrs(o, n) {
    var i, a;
    for (i = o.attributes.length - 1; i >= 0; i--) { a = o.attributes[i].name; if (!n.hasAttribute(a)) o.removeAttribute(a); }
    for (i = 0; i < n.attributes.length; i++) { a = n.attributes[i]; if (o.getAttribute(a.name) !== a.value) o.setAttribute(a.name, a.value); }
    if (o.nodeName === 'INPUT') { if (o.type === 'checkbox') o.checked = n.checked; else if (o !== document.activeElement && o.value !== n.value) o.value = n.value; }
  }
  function syncKids(o, n) {
    var nk = Array.prototype.slice.call(n.childNodes), ok = o.childNodes;
    nk.forEach(function (c, i) {
      var old = ok[i];
      if (!old) return o.appendChild(c);
      if (old.isEqualNode(c)) return;
      if (old.nodeType === 1 && c.nodeType === 1 && old.nodeName === c.nodeName && !(old.nodeName === 'INPUT' && old.type !== c.type)) {
        syncAttrs(old, c); syncKids(old, c);
        if (old.nodeName === 'SELECT') old.selectedIndex = c.selectedIndex;
        return;
      }
      o.replaceChild(c, old);
    });
    while (ok.length > nk.length) o.removeChild(o.lastChild);
  }
  function morph(el, html) { var t = document.createElement('div'); t.innerHTML = html; syncKids(el, t); }

  function renderSteps() {
    var n = 0, html = '';
    cfg.steps.forEach(function (st) {
      if (st.when && !st.when(S, api)) return;
      var lab = st.t === 'qty' ? 'Quantity' : st.label;
      if (lab) n++;
      html += '<div class="ved-step">' + (lab ? '<div class="ved-label"><span><b>' + ('0' + n).slice(-2) + '</b> / ' + esc(lab) + (st.unit ? ' · ' + st.unit : '') + '</span>' + (st.opt ? '<span class="ved-opt">optional</span>' : '') + '</div>' : '') +
        C[st.t](st) + (st.help ? '<span class="ved-sub">' + esc(val(st.help, S)) + '</span>' : '') + (notes[st.id] ? '<div class="ved-note" role="status">' + notes[st.id] + '</div>' : '') + '</div>';
    });
    morph($('.ved-steps'), html);
  }

  function messages() {
    var out = [];
    cfg.steps.forEach(function (st) {
      if (st.when && !st.when(S, api)) return;
      if (st.req && st.t === 'upload' && !files[cfg.key + ':' + st.id]) out.push({ level: 'error', msg: 'Upload ' + (st.reqName || 'your artwork') + ' to continue.' });
      else if (st.req && st.t !== 'upload' && !String(S[st.id] || '').trim()) out.push({ level: 'error', msg: 'Enter ' + (st.reqName || String(st.label).toLowerCase()) + '.' });
      if (st.t === 'confirm' && !S[st.id]) out.push({ level: 'error', msg: 'Tick the confirmation box to continue.', quiet: true });
      if (st.t === 'vehicle' && (!S.veh_make || !String(S.veh_model).trim() || !(+S.veh_year >= 1960))) out.push({ level: 'error', msg: 'Tell us the make, model and year so we cut it to your car.' });
    });
    return out.concat(cfg.check ? cfg.check(S, api) || [] : []);
  }

  function paint() {
    keep();   /* every change ends in a paint, so this is where remembered answers are saved */
    morph($('.ved-stage'), '<svg viewBox="0 0 600 400" role="img" aria-label="' + esc(cfg.name) + ' preview">' + cfg.draw(S, api) + '</svg>');
    $('.ved-meta').innerHTML = '<b>' + esc(cfg.meta(S, api)) + '</b>';
    var p = priceNow(), msgs = messages(), blocked = msgs.some(function (m) { return m.level === 'error'; });
    $('.ved-total').textContent = money(p.total);
    $('.ved-unit').textContent = p.qty > 1 ? p.qty + ' × ' + money(p.each) + ' each' : '';
    $('.ved-msgs').innerHTML = msgs.filter(function (m) { return !m.quiet; }).map(function (m) { return '<div class="ved-note is-' + m.level + '">' + m.msg + '</div>'; }).join('');
    var btn = $('.ved-add'), q = $('.ved-quote');
    btn.hidden = !p.variant; q.hidden = !!p.variant;
    btn.disabled = blocked;
    if (enquiry()) $('.ved-msgs').innerHTML += '<div class="ved-note">Happy with it? Send us this design and we’ll confirm the price and get it cut. Your design details are copied for you to paste into the message.</div>';
    else if (!p.variant) $('.ved-msgs').innerHTML += '<div class="ved-note">This one is bigger than we sell online. Send it over and we’ll price it properly.</div>';
  }

  /* ---------- enquiry mode ----------
     A store without the price-anchor product (another shop reusing a designer) can't bill
     through the cart, so the quote button opens the contact page with the design summary
     on the customer's clipboard. */
  function enquiry() { return !Object.keys(anchors[cfg.anchor] || {}).length; }
  function summary() {
    var p = cfg.props(S, api), k, out = [cfg.name + ' — ' + cfg.meta(S, api), 'Price shown: ' + money(priceNow().total)];
    for (k in p) if (p[k] !== '' && p[k] != null) out.push(k + ': ' + p[k]);
    return out.join('\n');
  }
  function sendDesign(e) {
    if (!enquiry()) return;
    e.preventDefault();
    var go = function () { window.location.href = opts.quote; };
    try { navigator.clipboard.writeText(summary()).then(go, go); } catch (x) { go(); }
  }

  /* ---------- the size rule ---------- */
  function applySize(st, key, raw) {
    var f = st.fields.filter(function (x) { return st.id + '_' + x.k === key; })[0], step = f.step || 1;
    var v = Math.round(raw / step) * step, msg = '';
    if (isNaN(v)) v = f.v;
    var max = val(f.max, S), min = val(f.min, S);
    if (v > max) { v = max; msg = max + ' ' + (st.unit || 'cm') + ' is ' + (f.why || 'the most you can order online') + '. Need it bigger? ' + quoteLink() + '.'; }
    if (v < min) v = min;
    S[key] = v;
    if (st.pairMax && st.fields.length === 2) {
      var a = st.id + '_' + st.fields[0].k, b = st.id + '_' + st.fields[1].k;
      if (S[a] > st.pairMax && S[b] > st.pairMax) {
        var other = key === a ? b : a, of = st.fields[key === a ? 1 : 0];
        S[other] = st.pairMax;
        msg = 'One side has to be ' + st.pairMax + ' cm or less — that’s the widest we ' + (st.pairMax === VED.LIMITS.cut ? 'cut' : 'print') + ' — so the ' + of.l.toLowerCase() + ' is now ' + st.pairMax + ' cm. Need both bigger? ' + quoteLink() + '.';
      }
    }
    notes[st.id] = msg;
  }
  /* a limit can depend on other answers (letters with tails cut shorter), so
     re-check every visible size after any change - without re-rendering, which
     would steal focus from the field being typed in */
  function reclamp() {
    cfg.steps.forEach(function (st) {
      if (st.t !== 'size' || (st.when && !st.when(S, api))) return;
      st.fields.forEach(function (f) {
        var key = st.id + '_' + f.k, mx = val(f.max, S), el = document.getElementById(ID(st, f.k));
        if (el) el.max = mx;
        if (S[key] > mx) { S[key] = mx; if (el) el.value = mx; }
      });
    });
  }
  function sizeStep(id) { return cfg.steps.filter(function (x) { return x.t === 'size' && x.id === id; })[0]; }

  /* ---------- uploads ---------- */
  function takeFile(id, file) {
    var st = cfg.steps.filter(function (x) { return x.id === id; })[0], key = cfg.key + ':' + id;
    notes[id] = '';
    if (!file) return;
    if (file.size > 20 * 1024 * 1024) { notes[id] = 'That file is ' + Math.round(file.size / 1048576) + ' MB. The limit is 20 MB — export a smaller PDF or email it to us after ordering.'; return renderSteps(); }
    var rec = files[key] = { name: file.name, file: file, url: '', w: 0, h: 0 };
    if (/^image\//.test(file.type)) {
      rec.url = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function () { rec.w = img.naturalWidth; rec.h = img.naturalHeight; if (st.minpx && Math.min(rec.w, rec.h) < st.minpx && !/svg/.test(file.type)) notes[id] = 'This image is ' + rec.w + ' × ' + rec.h + ' px. It may print soft — a vector file or at least ' + st.minpx + ' px on the short side is safer.'; renderSteps(); paint(); };
      img.src = rec.url;
    } else if (st.readText && /\.(csv|txt)$/i.test(file.name)) {
      var r = new FileReader();
      r.onload = function () { rec.text = String(r.result); renderSteps(); paint(); };
      r.readAsText(file);
    }
    renderSteps(); paint();
  }

  /* ---------- cart ---------- */
  function addToCart() {
    var p = priceNow(), btn = $('.ved-add');
    if (!p.variant || messages().some(function (m) { return m.level === 'error'; })) return;
    var fd = new FormData(), props = cfg.props(S, api), k;
    fd.append('id', p.variant); fd.append('quantity', 1);
    fd.append('properties[Product]', cfg.name);
    for (k in props) if (props[k] !== '' && props[k] != null) {
      if (String(props[k]).length > 400) fd.append('properties[' + k + ' (file)]', new File([String(props[k])], k.toLowerCase().replace(/\W+/g, '-') + '.txt', { type: 'text/plain' }));
      else fd.append('properties[' + k + ']', props[k]);
    }
    fd.append('properties[Quantity (units)]', p.qty);
    fd.append('properties[Unit price]', money(p.each));
    fd.append('properties[Price]', money(p.total));
    cfg.steps.forEach(function (st) { var f = st.t === 'upload' && files[cfg.key + ':' + st.id]; if (f) fd.append('properties[' + (st.prop || st.label || 'Artwork') + ']', f.file, f.name); });
    fd.append('properties[_designer]', cfg.key);
    btn.disabled = true; btn.firstChild.textContent = 'Adding… ';
    fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
      .then(function (r) { if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Cart error'); }); window.location.href = '/cart'; })
      .catch(function (e) { btn.disabled = false; btn.firstChild.textContent = 'Add to cart '; $('.ved-msgs').innerHTML = '<div class="ved-note is-error">Couldn’t add that to the cart: ' + esc(e.message) + '. Try again, or ' + quoteLink('send it to us as a quote') + '.</div>'; });
  }

  /* ---------- events ---------- */
  function bind() {
    var steps = $('.ved-steps');
    steps.addEventListener('input', function (e) {
      var el = e.target, k = el.dataset.k;
      if (el.dataset.hr) { S[el.dataset.hr][el.dataset.day][+el.dataset.i] = el.value; return paint(); }
      if (!k || k === 'qty') return;
      if (el.dataset.size) { var st = sizeStep(el.dataset.size), f = st.fields.filter(function (x) { return st.id + '_' + x.k === k; })[0], v = parseFloat(el.value); if (isNaN(v) || v < val(f.min, S) || v > val(f.max, S)) return; S[k] = v; return paint(); }
      S[k] = el.type === 'number' ? (el.value === '' ? '' : +el.value) : el.value;
      var c = steps.querySelector('[data-count="' + k + '"]'); if (c) c.textContent = el.value.length + ' / ' + el.maxLength;
      reclamp(); paint();
    });
    steps.addEventListener('change', function (e) {
      var el = e.target, k = el.dataset.k;
      if (el.dataset.up) return takeFile(el.dataset.up, el.files && el.files[0]);
      if (el.dataset.tick) { S[el.dataset.tick] = el.checked; return paint(); }
      if (k === 'qty') { var qs = cfg.steps.filter(function (x) { return x.t === 'qty'; })[0]; S.qty = Math.max(qtyMin(qs), Math.min(9999, parseInt(el.value, 10) || 1)); }
      else if (el.dataset.size) applySize(sizeStep(el.dataset.size), k, parseFloat(el.value));
      else if (!k) return;
      renderSteps(); paint();
    });
    steps.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b || b.disabled) return;
      var d = b.dataset, qs = cfg.steps.filter(function (x) { return x.t === 'qty'; })[0];
      if (d.q) S.qty = Math.max(qtyMin(qs), S.qty + (+d.q));
      else if (d.qset) S.qty = +d.qset;
      else if (d.rm) { delete files[cfg.key + ':' + d.rm]; notes[d.rm] = ''; }
      else if (d.preset) { var st = sizeStep(d.preset); d.v.split(',').forEach(function (v, i) { S[st.id + '_' + st.fields[i].k] = +v; }); notes[st.id] = ''; }
      else if (d.multi) { var a = S[d.set], i = a.indexOf(d.v); if (i > -1) { if (a.length > 1) a.splice(i, 1); } else a.push(d.v); }
      else if (d.set) { S[d.set] = d.v; if (cfg.onSet) cfg.onSet(d.set, S, api, notes); }
      else return;
      renderSteps(); paint();
    });
    $('.ved-add').addEventListener('click', addToCart);
    $('.ved-quote').addEventListener('click', sendDesign);
  }

  /* ---------- shell + hub ---------- */
  function shell() {
    root.innerHTML = '<a class="ved-back" href="' + esc(opts.hub) + '">← All designers</a><div class="ved-shell">' + (root.dataset.head === 'off' ? '' : '<div class="ved-head"><div><span class="ved-eyebrow">Design online</span><h1 class="ved-name">' + esc(cfg.name) + '</h1></div><div class="ved-facts">' + esc(cfg.facts) + '</div></div>') +   /* data-head="off": the page renders its own H1 */
      '<div class="ved-grid"><div class="ved-stagecol"><div class="ved-stagewrap"><div class="ved-stage"></div><div class="ved-stagefoot ved-mono"><span class="ved-meta"></span><span>Preview to scale · not a print proof</span></div></div></div>' +
      '<div class="ved-rail"><div class="ved-steps"></div><div class="ved-pricebar"><div class="ved-msgs" aria-live="polite"></div><div class="ved-pricerow"><span class="ved-eyebrow">Total</span><span><span class="ved-total">£0</span><div class="ved-unit"></div></span></div>' +
      '<button class="ved-btn ved-add" type="button">Add to cart <span aria-hidden="true">→</span></button><a class="ved-btn is-quote ved-quote" href="' + esc(opts.quote) + '" hidden>' + esc(root.dataset.quoteLabel || 'Get a free mockup and price') + '</a>' +
      '<span class="ved-fitted">' + (root.dataset.fitted ? esc(root.dataset.fitted) : 'Supplied ready to fit. Want it fitted? ' + quoteLink('Get a free mockup') + ' — West London, we come to you.') + '</span></div></div></div></div>';
  }
  function hub() {
    var groups = {}, html = '<div class="ved-hubhead"><span class="ved-eyebrow">Design online</span><h1>Design it here. <em>We make it.</em></h1><p>Pick a product, set it up to size and see it before you pay. Everything is made in our Ruislip workshop — and if it’s bigger than the page allows, we’ll quote it.</p></div>';
    /* On a real designer page (its handle is mapped, or it is the hub) link to each designer's own
       page; anywhere else (?view=designer previews, the harness) fall back to ?p= on this page. */
    var byKey = {}, H = VED.HANDLES || {}, onSite = root.dataset.handle === 'design-online' || !!H[root.dataset.handle];
    Object.keys(H).forEach(function (h) { byKey[H[h]] = h; });
    var link = function (k) { if (onSite && byKey[k]) return '/pages/' + byKey[k]; var u = new URL(location.href); u.searchParams.set('p', k); return u.pathname + u.search; };
    VED.order.forEach(function (k) { var c = VED.products[k]; (groups[c.group] = groups[c.group] || []).push('<a class="ved-tile" href="' + esc(link(k)) + '"><span class="h">' + esc(c.name) + '</span><span class="s">' + esc(c.tile || c.facts) + '</span></a>'); });
    (VED.EXTRA || []).forEach(function (x) { (groups[x.group] = groups[x.group] || []).push('<a class="ved-tile" href="' + esc(x.url) + '"><span class="h">' + esc(x.name) + '</span><span class="s">' + esc(x.s) + '</span></a>'); });
    (VED.GROUPS || Object.keys(groups)).forEach(function (g) { if (groups[g]) html += '<div class="ved-group ved-eyebrow">' + esc(g) + '</div><div class="ved-hub">' + groups[g].join('') + '</div>'; });
    root.innerHTML = html;
  }

  VED.init = function () {
    root = document.querySelector('.ved'); if (!root) return;
    opts = { quote: root.dataset.quote || '/pages/get-a-quote', hub: root.dataset.hub || '?' };
    try { anchors = JSON.parse(document.getElementById('ved-anchors').textContent); } catch (e) { anchors = {}; }
    var key = root.dataset.key, here = new URL(location.href), p = here.searchParams.get('p');
    /* reached with ?p= : the same page without it is the hub (keeps ?view= and preview params) */
    if (p) { here.searchParams.delete('p'); opts.hub = here.pathname + here.search; }
    if (!key || key === 'auto') key = p || (VED.HANDLES || {})[root.dataset.handle] || '';
    cfg = VED.products[key];
    if (!cfg) return hub();
    S = initState(cfg); recall(S); notes = {};
    shell(); renderSteps(); bind(); paint();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(paint);
    if (document.fonts && document.fonts.addEventListener) document.fonts.addEventListener('loadingdone', paint);
  };
  if (document.readyState !== 'loading') setTimeout(VED.init, 0); else document.addEventListener('DOMContentLoaded', VED.init);
})();
